import { render, staticRenderFns } from "./field-duplicate.vue?vue&type=template&id=8c2b8e0a&scoped=true&"
import script from "./field-duplicate.vue?vue&type=script&lang=js&"
export * from "./field-duplicate.vue?vue&type=script&lang=js&"
import style0 from "./field-duplicate.vue?vue&type=style&index=0&id=8c2b8e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2b8e0a",
  null
  
)

export default component.exports